// Die EINE Inhaltshuelle aller Seiten.
//
// WOFUER: ersetzt die im Audit gefundenen 6 verschiedenen Inhaltsbreiten und
// 7 verschiedenen `max-w`-Werte — und schliesst die 4 Routen, die GAR KEIN
// `max-w` hatten und auf 27"-Bildschirmen auseinanderlaufen.
//
// Genau eine Maximalbreite (1440px, `container-max` aus KINETIC-FLOW-SYSTEM.md)
// und genau ein Innenabstand. `narrow` (768px) ist fuer Lese- und Formularseiten.

import type { JSX, ComponentChildren } from "preact";

export type PageShellWidth = "default" | "narrow";

export interface PageShellProps {
  children: ComponentChildren;
  width?: PageShellWidth;
  class?: string;
}

const WIDTHS: Record<PageShellWidth, string> = {
  default: "max-w-[1440px]",
  narrow: "max-w-[768px]",
};

export function PageShell(props: PageShellProps): JSX.Element {
  const { children, width = "default", class: klass } = props;
  return (
    <div
      class={`mx-auto w-full ${WIDTHS[width]} px-4 py-6 sm:px-6 lg:px-8${
        klass ? ` ${klass}` : ""
      }`}
    >
      {children}
    </div>
  );
}
